import store from '@/store';
import { otpRepository } from '@/forms/api/repository-factory';
import callApi from '@/lib/helpers/call-api';
import { SET_SERVICE_STATUS } from '@/lib/constants/mutations';
import checkServiceStatus from '@/lib/helpers/check-service-status';
import FIELD_NAMES from '@/forms/constants/field-names';
import getValueByFieldName from '@/forms/helpers/get-value-by-field-name';

import {
    OTP_VALIDATE,
    SERVICE_STATUS,

} from '@/forms/constants/services';

const otpIsValid = () => checkServiceStatus(OTP_VALIDATE) === SERVICE_STATUS.success;

export default {
    validateAndBlockFields: async(step, callbacks) => {
        const { appId, formData: { values } } = store.state;
        const { form } = step;
        if (otpIsValid()) {
            return true;
        }

        const response = await callApi({
            callbacks,
            form,
            formElement: step,
            apiCall: otpRepository.validateOtpCode,
            payload: {
                'app-id': appId,
                otp: values[FIELD_NAMES.OTPCode],
                'validation-type': 'mobilephone',
            },
        });

        if (response.validation_status) {
            if (response.validation_status.toUpperCase() === 'SUCCESS') {
                store.commit(SET_SERVICE_STATUS, {
                    service: OTP_VALIDATE,
                    status: SERVICE_STATUS.success,
                });
                return true;
            }
            store.commit(SET_SERVICE_STATUS, {
                service: OTP_VALIDATE,
                status: SERVICE_STATUS.fail,
            });
        }


        return false;
    },

    validateAndBlockFieldsV2: async(step, callbacks) => {
        const { appId, formData: { values } } = store.state;
        const { form } = step;
        const customerMobileNumber = getValueByFieldName(values, FIELD_NAMES.phoneNumber);
        if (otpIsValid()) {
            return true;
        }

        const response = await callApi({
            callbacks,
            form,
            formElement: step,
            apiCall: otpRepository.validateOtpCodeV2,
            payload: {
                "target": customerMobileNumber,
                "otp": values[FIELD_NAMES.OTPCode],

            },
        });

        if (response.validation_status) {
            if (response.validation_status.toUpperCase() === 'SUCCESS') {
                store.commit(SET_SERVICE_STATUS, {
                    service: OTP_VALIDATE,
                    status: SERVICE_STATUS.success,
                });
                return true;
            }
            store.commit(SET_SERVICE_STATUS, {
                service: OTP_VALIDATE,
                status: SERVICE_STATUS.fail,
            });
        }


        return false;
    },
    validateAndBlockFieldsV3: async(step, callbacks) => {
        const { appId, formData: { values } } = store.state;
        const { form } = step;
        if (otpIsValid()) {
            return true;
        }

        const response = await callApi({
            callbacks,
            form,
            formElement: step,
            apiCall: otpRepository.validateOtpCodeV3,
            payload: {
                "target": customerMobileNumber,
                "otp": otpCode,

            },
        });

        if (response.validation_status) {
            if (response.validation_status.toUpperCase() === 'SUCCESS') {
                store.commit(SET_SERVICE_STATUS, {
                    service: OTP_VALIDATE,
                    status: SERVICE_STATUS.success,
                });
                return true;
            }
            store.commit(SET_SERVICE_STATUS, {
                service: OTP_VALIDATE,
                status: SERVICE_STATUS.fail,
            });
        }


        return false;
    },

    sendOtp: async(step, callbacks) => {
        const { form } = step;
        const { values } = store.state.formData;
        const { appId } = store.state;

        const firstName = getValueByFieldName(values, FIELD_NAMES.firstName);

        var name = ',' + firstName;
        if (otpIsValid()) {

            return true;
        }

        const response = await callApi({
            callbacks,
            form,
            formElement: step,
            apiCall: otpRepository.sendOtpCode,
            payload: appId + name,
        });

        return !!response;
    },
    sendOtpV2: async(currentStep, callbacks) => {
        const { form } = currentStep;
        const { values } = store.state.formData;
        const { appId, agentMobileNumber } = store.state;
        const customerMobileNumber = getValueByFieldName(values, FIELD_NAMES.phoneNumber);
        const response = await callApi({
            callbacks,
            form,
            formElement: currentStep,
            apiCall: otpRepository.sendOtpCodeV2,
            payload: customerMobileNumber,
        });

        return !!response;
    },
    sendOtpCustomer: async(step, callbacks) => {
        const { form } = step;
        const { values } = store.state.formData;
        const { appId, agentMobileNumber } = store.state;
        const customerMobileNumber = getValueByFieldName(values, FIELD_NAMES.phoneNumber);
        var appid = appId + ',';
        const response = await callApi({
            callbacks,
            form,
            formElement: step,
            apiCall: otpRepository.sendOtpCodeV3,
            payload: appid + customerMobileNumber,
        });

        return !!response;
    },
    resendOtp: async() => {

        const { values } = store.state.formData;
        const { appId } = store.state;

        const firstName = getValueByFieldName(values, FIELD_NAMES.firstName);
        var name = ',' + firstName;

        const response = await otpRepository.sendOtpCode(appId + name);

        return !!response;
    },
    resendOtpV2: async() => {

        const { values } = store.state.formData;
        const { appId } = store.state;

        const customerMobileNumber = getValueByFieldName(values, FIELD_NAMES.phoneNumber);

        const response = await otpRepository.sendOtpCodeV2(customerMobileNumber);

        return !!response;
    },
};